import { Add, Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import type { SetStateAction } from 'react';
import { useState, type Dispatch } from 'react';
import { useSelector } from 'react-redux';
import type { ILegalClientFullObject } from '../../Interfaces/ILegalClient';
import { type ILegalClientAddress } from '../../Interfaces/ILegalClientAddress';
import { State } from '../../redux/mainReducer';
import { UpdateOrCreateAddressDialog } from './UpdateOrCreateAddressDialog';

interface IProps {
  formValues: ILegalClientFullObject;
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
}

export const AddressTab = ({ formValues, setFormValues }: IProps) => {
  const [isMount, setIsMount] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<ILegalClientAddress>();

  const addressTypes = useSelector(
    (state: State) => state.addressTypeArray.storeAddressType
  );

  const onAdd = (address: ILegalClientAddress) =>
    setFormValues(prev => ({
      ...prev,
      AddressArray: [...prev.AddressArray, address],
    }));

  const onRemove = (addressId: number) =>
    setFormValues(prev => ({
      ...prev,
      AddressArray: prev.AddressArray.filter(a => a.idAddress !== addressId),
    }));

  const onUpdate = (address: ILegalClientAddress) => {
    setFormValues(prev => ({
      ...prev,
      AddressArray: prev.AddressArray.map(a =>
        a.idLegalClientAddress === address.idLegalClientAddress ? address : a
      ),
    }));

    setSelectedAddress(undefined);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h5'>Adressen</Typography>
        <Tooltip title='Adresse hinzufügen'>
          <IconButton onClick={() => setIsMount(true)}>
            <Add />
          </IconButton>
        </Tooltip>
      </Box>
      <Grid container spacing={2} mt={1}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Art</TableCell>
              <TableCell>Adresse</TableCell>
              <TableCell>Stadt</TableCell>
              <TableCell sx={{ width: 150 }}>Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formValues.AddressArray.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <i>Keine Adressen vorhanden.</i>
                </TableCell>
              </TableRow>
            ) : (
              formValues.AddressArray.map((a, i) => (
                <TableRow key={i}>
                  <TableCell>
                    {
                      addressTypes.find(
                        x => x.idAddresstype === a.idAddresstype
                      )?.Addresstype
                    }
                  </TableCell>
                  <TableCell>
                    {a.Street} {a.Number} {a.StreetAdditional}
                  </TableCell>
                  <TableCell>
                    {a.Postcode} {a.City}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setSelectedAddress(a);
                        setIsMount(true);
                      }}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => onRemove(a.idAddress)}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Grid>
      {isMount && (
        <UpdateOrCreateAddressDialog
          unmount={() => {
            setSelectedAddress(undefined);
            setIsMount(false);
          }}
          onSave={!!selectedAddress ? onUpdate : onAdd}
          selectedAddress={selectedAddress}
        />
      )}
    </Box>
  );
};
